import { RETRIEVE_SERVICE_APPROVALS, CREATE_SERVICE_APPROVAL, UPDATE_SERVICE_APPROVAL, DELETE_SERVICE_APPROVAL } from '../../actions/types';

const initialState = {
    items: [],
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
};

function serviceApprovalReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_SERVICE_APPROVALS:
            return {
                ...state,
                items: payload.data,
                totalItems: payload.totalItems,
                totalPages: payload.totalPages,
                currentPage: payload.currentPage,
            };

        case CREATE_SERVICE_APPROVAL:
            return {
                ...state,
                items: [payload, ...state.items],
                totalItems: state.totalItems + 1,
            };

        case UPDATE_SERVICE_APPROVAL:
            return {
                ...state,
                items: state.items.map((item) => (item.id === payload.id ? payload : item)),
            };

        case DELETE_SERVICE_APPROVAL:
            return {
                ...state,
                items: state.items.filter(({ id }) => id !== payload.id),
                totalItems: state.totalItems - 1,
            };

        default:
            return state;
    }
}

export default serviceApprovalReducer;
